module.exports = __webpack_public_path__ + "img/02@2x.2a960f85.png";